module.exports = __webpack_public_path__ + "img/img_yinying@2x.1658ece6.png";